import Actions from "../actions";
import { produce } from "immer";

const initialState = {
    faqs: {},
    selectedFaqId:"",
    faq:{}
};


const faqs = produce((draft = initialState, action) => {
  const { payload } = action;
  switch (action.type) {
    case Actions.GET_FAQS_LIST: {
      draft.faqs = payload?.faqs;
      break;
    }

    case Actions.SELECTED_FAQ_ID: {
      draft.selectedFaqId = payload?.selectedFaqId;
      break;
    }

    case Actions.GET_FAQ_BY_ID: {
      draft.faq = payload?.faq;
      break;
    }

    default: {
      break;
    }
  }
}, initialState);

export default faqs;
